export default __webpack_public_path__ + "static/media/star-icon.bc41fee6.svg";